(ns com.theplantscape.plant-web.draw.ui-plant-info
  (:require
   [cljs.pprint :as clojure.pprint]
   [com.theplantscape.local-store.ensemble :refer [update-entity]]
   [com.theplantscape.plant-web.components.tiles :refer [entity-tile]]
   [com.theplantscape.plant-web.draw.events :refer [move-ob rm-ob]]
   [com.theplantscape.plant-web.draw.state :refer [app-state reset-editing]]
   [com.theplantscape.web-ui.ensemble :as u]
   [reagent.core :as r]))


(defn set-current-plant-info [entity-id]
  (let [plant (-> @app-state :current :plant)]
    (update-entity entity-id :diagram.object/plant-entity-id (-> plant :db/id))
    (update-entity entity-id :diagram.object/plant-uuid (-> plant :plant/id))
    (update-entity entity-id :diagram.object/svg-filter (->  plant :plant/type name) )
    #_{:diagram.object/plant-entity-id (-> plant :db/id)
     :diagram.object/plant-uuid (-> plant :plant/id)
     :diagram.object/svg-filter (->  plant :plant/type name)})

  )
(comment 
  (set-current-plant-info 58))

(defn change-entity-plant-to-current-plant [entity-id]
  ;;update-entity
  (when (-> @app-state :current :plant)
    (prn "update entity plant")
    (-> @app-state :selected)
    (prn (-> @app-state :current ))
    (prn (-> @app-state :current :plant :db/id))
    (set-current-plant-info entity-id)
    )
  )


(defn ui-plant-info []
  (let [expanded (r/atom false)]
    (fn []
      (when (-> @app-state :selected :eid int?)
        #_(and
           #_(-> @app-state :selected :object :diagram.object/plant-entity-id int?))
        [:div.fixed.bottom-0.left-0.w-full.bg-white #_{:class (if (false? @expanded) #_"h-48" "h-18")}
         [:div.absolute.-top-2.right-0.m-1.w-8 {:on-click reset-editing} u/icon-close]
         (if (-> @app-state :debug)
           [:pre.overflow-auto.font-xs (clojure.pprint/write @app-state :stream nil)]
           [:div
            [entity-tile
             (-> @app-state :selected :eid)
             (-> @app-state :selected :object :diagram.object/plant-entity-id)
             ;(fetch-plant (-> @app-state :selected :object :diagram.object/plant-entity-id))
             {:remove-fn #(rm-ob (-> @app-state :selected :eid))
              :switch-plant-fn #(change-entity-plant-to-current-plant
                                 (-> @app-state :selected :eid))
              :move-fn #(move-ob (-> @app-state :selected :eid)
                                 (-> @app-state :pointer :current :pos)
                                 #_(-> @app-state :mouse :button :dragging))
              :info-fn #(swap! expanded not)
              :info-toggle @expanded}]])]))))
